import { StopnjaDDVEnum } from '../../Enum/StopnjaDDVEnum'

export const PretvorbaEnot = {
  methods: {
    PretvoriKolicinoVPrijaznoObliko (podatkiKb) {
      podatkiKb = parseInt(podatkiKb)
      let sizes = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      for (let i = 0; i < sizes.length; i++) {
        if (podatkiKb <= 1024) {
          return podatkiKb + ' ' + sizes[i]
        } else {
          podatkiKb = parseFloat(podatkiKb / 1024).toFixed(2)
        }
      }
      return podatkiKb
    },
    PretvoriKolicinoVPrijaznoOblikoB (podatkiB) {
      podatkiB = parseInt(podatkiB)
      let sizes = ['B', 'kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
      for (let i = 0; i < sizes.length; i++) {
        if (podatkiB < 1024) {
          return podatkiB + ' ' + sizes[i]
        } else {
          podatkiB = parseFloat(podatkiB / 1024).toFixed(2)
        }
      }
      return podatkiB
    },
    PretvoriKolicinoVPrijaznoOblikoMb (podatkiMb) {
      let obj = {}
      podatkiMb = parseInt(podatkiMb)
      if (podatkiMb < 1024 * 1024) {
        obj.vrednost = podatkiMb / (1024)
        obj.enota = 'MB'
      } else if (podatkiMb < 1024 * 1024 * 1024) {
        obj.vrednost = podatkiMb / (1024 * 1024)
        obj.enota = 'GB'
      } else if (podatkiMb < 1024 * 1024 * 1024 * 1024) {
        obj.vrednost = podatkiMb / (1024 * 1024 * 1024)
        obj.enota = 'TB'
      }
      return obj
    },
    PretvoriVkB (kolicina, enota) {
      let obj = {}
      kolicina = parseFloat(kolicina)
      switch (enota) {
        case 'kB':
          obj.vrednost = kolicina
          obj.enota = 'kB'
          break
        case 'MB':
          obj.vrednost = kolicina / (1024)
          obj.enota = 'MB'
          break
        case 'GB':
          obj.vrednost = kolicina / (1024 * 1024)
          obj.enota = 'GB'
          break
        case 'TB':
          obj.vrednost = kolicina / (1024 * 1024 * 1024)
          obj.enota = 'TB'
          break
      }
      return obj
    },
    PretvoVEurIzEvroCentov (kolicina) {
      let eur = kolicina / 100
      return (eur + ((StopnjaDDVEnum.DDV_PROCENTUALNO / 100) * eur)).toFixed(2)
    },
    PretvoriMeritveHitrosti (podatkiMb) {
      let obj = {}
      podatkiMb = parseInt(podatkiMb)
      if (podatkiMb < 1024 * 1024) {
        obj.vrednost = podatkiMb / (1024)
        obj.enota = 'Mbit/s'
      } else if (podatkiMb < 1024 * 1024 * 1024) {
        obj.vrednost = podatkiMb / (1024 * 1024)
        obj.enota = 'Gbit/s'
      } else if (podatkiMb < 1024 * 1024 * 1024 * 1024) {
        obj.vrednost = podatkiMb / (1024 * 1024 * 1024)
        obj.enota = 'Tbit/s'
      }
      return obj
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/PretvorbaEnotB.js